import ObexRequestHandlerP80 from '../handlers/ObexRequestsHandlerP80';
import { getAccessToken, getErrorMessage, unwrapObject, buildQuery } from './apiUtils';

/**
 * Permisos del cajero logado, de /auth/me: los de sus roles directos y los que
 * le llegan por grupo, solo de roles activos.
 */
const ROUTES = {
    me: '/auth/me'
};

/** Cualquiera de los dos da acceso al arqueo: el de lectura y el que lo incluye todo. */
export const ARQUEO_PERMISSIONS = ['arqueo_tienda_read', 'arqueo_tienda_all'];

export const getMyPermissions = async (): Promise<string[]> => {
    const accessToken = getAccessToken();
    if (!accessToken) throw new Error('No autorizado');

    const res = await ObexRequestHandlerP80.get(`${ROUTES.me}${buildQuery({ access_token: accessToken })}`);
    const error = getErrorMessage(res);
    if (error) throw new Error(error);

    const body = unwrapObject(res) || {};
    const list = Array.isArray(body.permissions) ? body.permissions : [];
    return list.map((p: any) => String(p && p.code ? p.code : p)).filter(Boolean);
};

export const hasAnyPermission = (granted: string[], wanted: string[]): boolean =>
    wanted.some(code => granted.indexOf(code) !== -1);
